module.exports = __webpack_public_path__ + "img/send_03.bdb3b95d.png";